import React from 'react';
import { DropdownIcon } from '../../assets/DropdownIcon';
import classNames from 'classnames';
import { MenuParts } from '../../constants';
import {
  formatClassNames,
  HAS_CUSTOM_FOCUS_CLASSNAME,
} from '@wix/editor-elements-common-utils';
import classes from './style/MenuItem.module.scss';
import { semanticClassNames as menuSemanticClassNames } from '../../../Menu.semanticClassNames';

export interface IMenuItemDropdownIconProps {
  chevronButtonRef: React.RefObject<HTMLButtonElement>;
  onClick: () => void;
  isOpen: boolean;
  hasSubItems: boolean;
  hasLink: boolean;
  isDropdownIconOpen: boolean;
  className?: string;
  ariaLabel?: string;
  srOnly: boolean;
  submenuToggleId?: string;
}

export const MenuItemDropdownIcon: React.FC<IMenuItemDropdownIconProps> = ({
  chevronButtonRef,
  onClick,
  isOpen,
  hasSubItems,
  hasLink,
  ariaLabel,
  isDropdownIconOpen,
  className,
  srOnly,
  submenuToggleId,
}) => {
  const button = (
    <button
      aria-label={ariaLabel}
      ref={chevronButtonRef}
      className={classNames(
        classes.dropdownToggleButton,
        HAS_CUSTOM_FOCUS_CLASSNAME,
        !hasSubItems && classes.noDropdownItems,
        !hasLink && classes.coverAllSpace,
        className,
      )}
      onClick={onClick}
      aria-expanded={isOpen}
      {...(!srOnly && { 'data-part': MenuParts.DropdownButton })}
    >
      <DropdownIcon
        data-part={MenuParts.DropdownIcon}
        data-open={isDropdownIconOpen ? 'true' : undefined}
        className={classNames(
          classes.dropdownIcon,
          formatClassNames(menuSemanticClassNames.itemIcon),
        )}
      />
    </button>
  );

  return submenuToggleId ? (
    <span className={classes.submenuToggleWrapper}>
      <label
        htmlFor={submenuToggleId}
        className={classes.submenuToggleLabel}
        data-submenu-toggle-label=""
        aria-hidden="true"
      />
      {button}
    </span>
  ) : (
    button
  );
};
